import React from 'react';
import { ExampleProps } from './Example.interface';
import { ServicesData } from 'app/utils';
import styles from './Example.module.scss';

export const Example: React.FC<ExampleProps> = ({ service }) => {
  if (!(service in ServicesData)) return <></>;
  if (!('ExampleImage' in ServicesData[service])) return <></>;

  return (
    <div className={styles.insights}>
      <div className={styles.wrapper}>
        <h3 className={styles['heading-3']}>
          {ServicesData[service].ExampleHeading}
        </h3>
        <img
          src={ServicesData[service].ExampleImage}
          alt="Data extraction Example"
          aria-hidden
        />
      </div>
    </div>
  );
};
